import { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import { forgotPasswordSchema } from '../../../validations/forgotPassword'
import { endpoints, postFunc } from '../../../api'
import { showToast } from '../../../utils/toast'
import useAuth from '../../../hooks/useAuth'
import DefaultButton from '../../../components/Button/Button'
import DarkSafeltoLogo from '../../../assets/icons/SafeltoLogo'
import SafeltoShortLogo from '../../../assets/icons/SalfetoShortLogo.svg'
import { Link } from 'react-router-dom'

const ForgotPasswordPage = () => {
  useAuth({ to: '/dashboard' })

  const [loading, setLoading] = useState(false)
  const [countDown, setCountDown] = useState(0)
  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: forgotPasswordSchema,
    async onSubmit(values) {
      if (loading || !formik.isValid || !!countDown) {
        return
      }
      setLoading(true)
      try {
        await postFunc(`${endpoints.forgotPassword}?userType=STAFF`, {
          ...values,
        })
        setCountDown(30)
        showToast({
          id: 'forgot-password',
          title: 'Password reset sent',
          description: 'We have sent a link to reset your password to your email',
          status: 'success',
        })
      } catch {
      } finally {
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    let intervalId: NodeJS.Timeout

    if (countDown > 0) {
      intervalId = setInterval(() => {
        setCountDown((count) => count - 1)
      }, 1000)
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [countDown])

  return (
    <>
      <div className="p-10">
        <div className="mb-14">
          <Link to={'/'}>
            <DarkSafeltoLogo />
          </Link>
        </div>
        <div className="flex flex-col justify-center items-center gap-14">
          <div className="flex flex-col items-center justify-center gap-10">
            <div>
              {' '}
              <img src={SafeltoShortLogo} alt="Logo" className="w-10 h-10" />
            </div>
            <div className="">
              <p className="font-bold text-lg text-center">Reset password</p>
              <p className="font-medium text-base text-gray-400">
                Please enter your email address
              </p>
            </div>
          </div>
          <form onSubmit={formik.handleSubmit} className="w-full max-w-md">
            <div className="space-y-6 text-center">
              <input
                type="email"
                className="border border-solid border-gray-300 px-4 py-4 rounded-lg focus:outline-none focus:border-blue-500 w-full mb-12"
                placeholder="dolores.chambers@safelto.com"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
              />
              <DefaultButton
                background="gray.900"
                color="white"
                type="submit"
                size="lg"
                isLoading={loading}
                loadingText="Submitting..."
                disabled={loading || !!countDown}
                cursor={!!countDown ? 'wait' : 'pointer'}
                className="w-full p-7"
              >
                Continue
              </DefaultButton>
              {!!countDown ? <p>Button will reactivate in {countDown} seconds</p> : null}
              <p>
                Remember password?{' '}
                <a href="/auth/login" className="text-primary-300">
                  Login
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default ForgotPasswordPage
